import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="py-20" aria-labelledby="faq-title" data-id="element-45" data-mp="1ceqcvl9bmtg8">
      <div className="mx-auto max-w-3xl px-4" data-id="element-46" data-mp="1cgb719rq4adk">
        <SectionHeading id="faq-title" data-id="element-47" data-mp="2a2s2sakt6fx7">Domande <span className="text-gold" data-id="element-48" data-mp="2a1qgf9yce706">frequenti</span></SectionHeading>
        <div className="mt-10 space-y-3" data-id="element-49" data-mp="252vyea878mh4">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className={`overflow-hidden rounded-xl border bg-navy-card transition-colors duration-150 ease-out ${isOpen ? 'border-energy/60' : 'border-aqua/20'}`} data-id="element-50" data-mp="2065l1uns44ze" data-mpi={index}>
                <h3 className="font-sans" data-id="element-51" data-mp="oq77pelkiwsd">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-bold text-cream transition-colors duration-150 ease-out hover:bg-navy-light focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-gold/50 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-52" data-mp="jpb30yte76lw">
                    <span data-id="element-53" data-mp="1arwx7959ue8i">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-energy transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-54" data-mp="1fnud5ecmhikr" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-55" data-mp="16oqto99jn15q">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-56" data-mp="rzb2is63otpi">
                      <p className="border-t border-aqua/10 px-5 py-4 leading-relaxed text-haze sm:px-6" data-id="element-57" data-mp="2pmn4fvgnvtzm">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}